import {useMemo, useState} from 'react';
import {Button, Checkbox, FormControlLabel, Stack, TextField, Typography} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ResponsiveDialog from 'src/components/modals/ResponsiveDiaog';
import {getReceiptHtml, printJsonReceipt} from 'src/features/printer';
import {getSiteCurrency} from 'src/utils/selectors';

export default function AdvancedPrintModal({open, setOpen, order}) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const [showWeight, setShowWeight] = useState(true);
	const [deliveryFeeEnabled, setDeliveryFeeEnabled] = useState(true);
	const [useFixedPrice, setUseFixedPrice] = useState(false);
	const [hardcodedPrice, setHardcodedPrice] = useState('');
	const [currency, setCurrency] = useState(getSiteCurrency());

	const options = useMemo(
		() => ({
			show_weight: showWeight,
			delivery_fee_enabled: deliveryFeeEnabled,
			use_fixed_price: useFixedPrice,
			hardcoded_price: Number(hardcodedPrice) || 0,
			currency,
		}),
		[showWeight, deliveryFeeEnabled, useFixedPrice, hardcodedPrice, currency],
	);

	const {html, style} = useMemo(() => getReceiptHtml(order, options), [order, options]);

	const handlePrint = () => {
		printJsonReceipt(order, options);
		setOpen(false);
	};

	return (
		<ResponsiveDialog
			open={open}
			setOpen={setOpen}
			maxWidth="lg"
			title="طباعة متقدمة"
			actions={
				<Button variant="contained" onClick={handlePrint}>
					طباعة
				</Button>
			}
		>
			<Stack direction={{xs: 'column', md: 'row'}} spacing={3}>
				{!isMobile && (
					<Stack flex={1} sx={{border: '1px solid #eee', borderRadius: 1, overflow: 'hidden'}}>
						<iframe
							title="معاينة الفاتورة"
							srcDoc={`<style>${style}</style>${html}`}
							style={{width: '100%', height: 600, border: 'none'}}
						/>
					</Stack>
				)}

				<Stack flex={1} spacing={1}>
					<Typography variant="h6">اعدادات الطباعة</Typography>

					<TextField
						label="رمز العملة"
						value={currency}
						onChange={(e) => setCurrency(e.target.value)}
						size="small"
					/>
					<FormControlLabel
						control={<Checkbox checked={showWeight} onChange={(e) => setShowWeight(e.target.checked)} />}
						label="عرض الوزن"
					/>
					<FormControlLabel
						control={
							<Checkbox
								checked={deliveryFeeEnabled}
								onChange={(e) => setDeliveryFeeEnabled(e.target.checked)}
							/>
						}
						label="عرض سعر التوصيل"
					/>
					<FormControlLabel
						control={
							<Checkbox checked={useFixedPrice} onChange={(e) => setUseFixedPrice(e.target.checked)} />
						}
						label="سعر ثابت"
					/>
					{useFixedPrice && (
						<TextField
							type="number"
							label="السعر الثابت"
							value={hardcodedPrice}
							onChange={(e) => setHardcodedPrice(e.target.value)}
							size="small"
						/>
					)}
				</Stack>
			</Stack>
		</ResponsiveDialog>
	);
}
